import { IconDownload } from "@tabler/icons-react";

import { Input, Text } from "@fragments";

import { EXPORT_FIELDS, EXPORT_FORMATS } from "../enums";

import "./styles.scss";

export default function ExportMembersView({
  ModalComponent,
  open,
  onClose,
  format,
  setFormat,
  fields,
  toggleField,
  submitting,
  canSubmit,
  onSubmit,
}) {
  return (
    <ModalComponent
      maxWidth={520}
      open={open}
      handleClose={onClose}
      loading={submitting}
      disabled={!canSubmit}
      title="Exportar membros filtrados"
      bottomButtonSumbitText="Iniciar exportação"
      bottomButtonSumbitIcon={<IconDownload size={18} stroke={2} />}
      bottomButtonCancelText="Cancelar"
      handleSubmit={onSubmit}
      bodyComponent={
        <div className="export-members px-4 py-3">
          <Text.h4 contrast={8} weight={500}>
            Formato do arquivo
          </Text.h4>
          <Text.span contrast={5}>
            Escolha em qual formato a planilha será gerada.
          </Text.span>

          <Input.Select
            className="mt-2"
            label="Formato"
            value={format}
            onInput={setFormat}
            options={EXPORT_FORMATS.map((f) => ({
              label: f.label,
              value: f.id,
            }))}
          />

          <div className="export-members__divider" />

          <Text.h4 contrast={8} weight={500}>
            Campos a exportar
          </Text.h4>
          <Text.span contrast={5}>
            Selecione quais informações de cada membro devem ser incluídas.
          </Text.span>

          <div className="export-members__fields mt-2">
            {EXPORT_FIELDS.map((field) => (
              <Input.Switch
                key={field.id}
                label={field.label}
                value={fields.includes(field.id)}
                onInput={(enabled) => toggleField(field.id, enabled)}
              />
            ))}
          </div>
        </div>
      }
    />
  );
}
